import React, { ReactElement } from "react"
import { Typography } from "@material-ui/core"

export const CFC4QsTourContent = (): ReactElement => (
	<div className="content-area">
		<Typography variant="h6">Cash Flow</Typography>
		<Typography>
			Vizuelno prikazuje vaš novčani tok i olakšava uvid u vaše poslovanje
			daljući odgovore na Četiri ključna pitanja.
		</Typography>
		<br />
		<Typography>
			Ovo će vam pomoći da razumete svoj trenutni položaj i identifikujete bilo
			koji poboljšanja koja biste mogli da napravite u svom poslu.
		</Typography>
	</div>
)

export const CFCCreateCanvas = (): ReactElement => (
	<div className="content-area">
		<Typography variant="h6">Kreirajte Cash Flow Canvas</Typography>

		<Typography>
			Prvo možete da napravite prilagođeno ime koje će vam pomoći da
			identifikujete svaki Cash Flow, a zatim odaberite tip Cash Flow-a,
			vremenski okvir i opseg datuma.
		</Typography>
	</div>
)

export const CFCFillingOutCanvas = (): ReactElement => (
	<div className="content-area">
		<Typography variant="h6">Popunite stavke</Typography>

		<Typography>Možete uneti.....</Typography>
		<Typography>
			Što je vaš cash flow jednostavniji, lakše ćete razumeti odnose između
			ključnih područja koja će uticati na vaš novčani tok.
		</Typography>
	</div>
)

export const CFCYourPosition = (): ReactElement => (
	<div className="content-area">
		<Typography variant="h6">Razumevanje vašeg pozicije</Typography>

		<Typography>
			Lako pogledajte da li vaše poslovanje napreduje ili zaostaje.
		</Typography>
	</div>
)

export const CFCControlPanel = (): ReactElement => (
	<div className="content-area">
		<Typography variant="h6">Kontrolna tabla</Typography>

		<Typography>
			Ovde možete otvoriti postojeći cash flow, kopirati, izbrisati ili stvoriti
			novi.
		</Typography>
		<br />
	</div>
)
